import { Component, OnInit, Input,ChangeDetectorRef } from '@angular/core';
import { Constants } from '../../../../shared/models/constants';
import * as _ from 'lodash';

@Component({
  selector: 'app-addEnrichmentOptions',
  templateUrl: './addEnrichmentOptions.component.html',
  styleUrls: ['./addEnrichmentOptions.component.css']
})
export class AddEnrichmentOptionsComponent implements OnInit {
  @Input() data: any;
  public pagesTabActive: boolean = false;
  public basicOptionsActive: boolean = true;
  public newChildOptionsActive: boolean = false;
  public addAsSibling: boolean;
  public childAttachType: any;
  public headerName: any;
  isDisplayPageOptions = true;
  isDisplayGoogleTabs = true;
  public disableSaveAsTemplate: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {

    var enrichmentOptions = Constants.getEnrichmentOptions();
    var keys = Object.keys(enrichmentOptions);
    keys.forEach(key => {
      if (enrichmentOptions[key].isService)
        this.servicesOptions.push(enrichmentOptions[key]);
      else
        this.pageOptions.push(enrichmentOptions[key]);
    });
  }

  ngOnInit() {
    if (this.data.popupProps.curComp.addTabtype == 'firstLevelGlobal' || this.data.popupProps.curComp.addTabtype == 'secondLevelGlobal') {
      this.newChildOptionsActive = true;
      this.pagesTabActive = true;
      this.basicOptionsActive = false;
    }
    if (this.data.popupProps.curComp.parent == 'ELE' || this.data.popupProps.curComp.parent == 'CreatedEBE') {
      this.pageOptions = this.pageOptions.filter(function (obj) {
        return obj.type !== "duplicateAsImage";
      });
    }
    else{
      this.pageOptions = this.pageOptions.filter(function (obj) {
        return obj.type !== "duplicateAsPage";
      }); 
    }
    //To disable Save as Template button in case of current selected tab other than blank page and page from book
    this.disableSaveAsTemplateButton();
  }


  public pageOptions = [];


  public servicesOptions = [];

  onPagesClick(evt): void {
    evt.stopPropagation();
    this.pagesTabActive = true;
    this.basicOptionsActive = false;
    this.newChildOptionsActive = true;
  }

  onServicesClick(evt): void {
    evt.stopPropagation();
    document.getElementsByClassName("globalpopup")[0]['style'].height = "auto";

    this.data.togglePopup = false;

    this.pagesTabActive = false;
    this.basicOptionsActive = false;
    this.newChildOptionsActive = true;
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }

  }

  onpageClick(clickeddata, evt) {
    evt.stopPropagation();
    this.data.popupProps.showPopup = false;
    if (clickeddata.type == "googleCalender" || clickeddata.type == "googleMaps" || clickeddata.type == "mindmap") {
      return;
    }
    this.data.popupProps.curComp.callBack(clickeddata, this.childAttachType);

    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }

  }

  onBasicOptionClick(clickeddata, evt, name) {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }
    evt.stopPropagation();
    if (clickeddata == "addSiblingRight" || clickeddata == "addSiblingLeft" || clickeddata == "addChildren") {
      document.getElementsByClassName("globalpopup")[0]["style"].height = "auto";

      this.data.togglePopup = false;

      this.pagesTabActive = true;
      this.basicOptionsActive = false;
      this.newChildOptionsActive = true;
      this.childAttachType = clickeddata;
      this.headerName = name;
    }
    else if (clickeddata == "delete" || clickeddata == "edit" || clickeddata == "saveAsTemplate") {
      this.data.popupProps.showPopup = false;
      this.data.popupProps.curComp.callBack(undefined, clickeddata);
    }
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }
  }

  backToBasicOptions(evt) {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }

    evt.stopPropagation();
    this.pagesTabActive = false;
    this.basicOptionsActive = true;
    this.newChildOptionsActive = false;
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges()
    }

  }

  disableSaveAsTemplateButton() {

    let tempArray = ["blankPage", "pageFromBook", "template", "duplicateAsImage", "duplicateAsPage"];

    if (this.data.popupProps.curComp.addTabtype == "firstLevelChild") {
      if (this.data.popupProps.curComp.CurrentSelectedObj) {

        if (tempArray.indexOf(this.data.popupProps.curComp.CurrentSelectedObj.type) == -1) {
          this.disableSaveAsTemplate = true;
        }
      }
    }
    else if (this.data.popupProps.curComp.addTabtype == "secondLevelChild") {
      let CurrentSelectedObj = this.data.popupProps.curComp.CurrentSelectedObj;
      let activeSublevelIndex = this.data.popupProps.curComp.activeSublevelIndex;
      if (CurrentSelectedObj && activeSublevelIndex != undefined) {
        if (tempArray.indexOf(CurrentSelectedObj.children[activeSublevelIndex].type) == -1) {
          this.disableSaveAsTemplate = true;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/enrichmentTabPopups/AddEnrichmentOptions/addEnrichmentOptions.component.ts